let domLoaded = false;
let igReady = false;

// RA_PT_PDP_4 | Free Travel Mug. The gift set has to be resolved by scripts that run before
// handleExperiments() adds the body class on DOMContentLoaded (PDP form, product media,
// sidecart, sticky button, hero banners), so the group is also exposed as a helper. This file
// is loaded synchronously right after the render-blocking Intelligems bundle, so igData is
// already populated by the time any of them call it.
// Matched on the "Var A" prefix rather than the full group name: the dashboard label has been
// seen both with and without a trailing " ID", and the test only has a control and a Var A.
window.cFreeTravelMugVarA = function () {
  const name = window.igData?.user?.getTestGroup("57123a32-40cf-43cc-b86d-794b827d453e")?.name;
  return typeof name === "string" && name.startsWith("Var A");
};

// HP | Media grid 3 vs 5 blocks vs full screen hero (sections/media-grid-v2.liquid test_slot
// settings + sections/c-hero-fullscreen.liquid). The class is also put on <html> as soon as the
// group is known, without waiting for DOMContentLoaded: the Intelligems bundle is render-blocking,
// so the first paint already has the variant layout instead of flashing Control's grid.
// QA without being bucketed: ?ig_preview=hpMediaGridA / hpMediaGridB / hpMediaGridC
window.cHpMediaGridClass = function () {
  const preview = {
    hpMediaGridA: "c-hpMediaGrid-varA",
    hpMediaGridB: "c-hpMediaGrid-varB",
    hpMediaGridC: "c-hpMediaGrid-varC",
  }[new URLSearchParams(window.location.search).get("ig_preview")];
  if (preview) return preview;

  const name = window.igData?.user?.getTestGroup("5b401b19-6c00-4d22-9e92-bcc302c5ad1b")?.name;
  if (name === "Var A - 3 blocks") return "c-hpMediaGrid-varA";
  if (name === "Var B - 5 blocks") return "c-hpMediaGrid-varB";
  if (name === "Var C - Mobile Full screen") return "c-hpMediaGrid-varC";
  return null;
};

function flagHpMediaGridOnRoot() {
  const className = window.cHpMediaGridClass();
  if (className) document.documentElement.classList.add(className);
}
flagHpMediaGridOnRoot();
window.addEventListener("ig:ready", flagHpMediaGridOnRoot);

function handleExperiments() {
  if (!domLoaded || !igReady) return;

    // V_PT_PDP_17 | Cart Value Badge — CONCLUDED (Control winner, test
    // 5be2b1a9-e8e5-46eb-998c-0aa0ea99202e). Var A replaced the header/drawer item-count
    // bubble with the running cart total in euros and did not beat Control, so the euro
    // badge is gone: assets/c-cart-value-badge.css/.js and snippets/c-cart-value-badge.liquid
    // are deleted, and the header + cart drawer render the item count exactly as before.

    // V_PT_COL_20 | Collection-USP-Grid — CONCLUDED (Control winner, test
    // 31bbdedd-074e-49a9-b000-aa64129f9c5f). Var A injected four USP trust cards into the
    // collection product grid and did not beat Control, so the cards are gone:
    // assets/c-collection-usp-grid.css and snippets/c-collection-usp-grid.liquid are
    // deleted, both collection sections render the plain product grid again, and the
    // "AB Test — V_PT_COL_20" theme-settings group is removed.

    // V_PT_PDP_23 | Add 'Le Plus Populaire' Badge to Subscription Option — CONCLUDED
    // (Control winner, test f5309e24-02fb-4e81-a967-d3346c195173). Var A added the badge to
    // the "Abonnement" card and replaced the pack badges ("Offre populaire" / "Meilleure
    // valeur") with "xx€ de cadeaux offerts"; neither beat Control, so both are gone:
    // assets/c-subscription-popular-badge.css and snippets/c-subscription-popular-badge.liquid
    // are deleted, and the pack badges render their original labels again.

    // V_PT_PDP_13 | Display image with gifts when subscription is ON — CONCLUDED (Var A
    // winner, tests 493f2516-6b36-4ead-84b6-ea43d4610be3 and duplicate rerun
    // 9bbdde88-aff2-4320-9038-27fe94d1e08b). The gift/subscription image swap is now the
    // unconditional default in assets/toggle-subscription-image.js/.css, so there is no
    // longer a body class to flip here.

    // V_PT_PROD_CARD_16 |  Blog Sticky CTA — Product Card with Bottom Sheet
    const V_PT_PROD_CARD_16 = window.igData?.user.getTestGroup("49d5a625-e5c3-4014-91d2-65b932c9168e");
    if (V_PT_PROD_CARD_16?.name === "Var A - Sticky Pop up") {
        document.body.classList.add("V_PT_PROD_CARD_16-varA");
    } else if (V_PT_PROD_CARD_16?.name === "Var B - Direct add-to-cart") {
        document.body.classList.add("V_PT_PROD_CARD_16-varB");
    }

    // V_PT_MIX_15 | Home page price visibility + CTA copy — CONCLUDED (Var C
    // "start at & discover cta" winner, test 1872c0c0-3b79-4fcd-9546-2e825e3e85fc).
    // Eligible home-page cards (theme.redirect_to_pdp products, gated by
    // settings.c_mix15_enabled) now always show the "from" lowest price and the PDP link in
    // place of the normal price and quick-add. That is the unconditional default in
    // snippets/product-card.liquid + assets/c-custom.css, so there is no longer a body class
    // to flip here. The CTA links to the PDP and never adds to cart.

    // RA_PT_CART | New gift design on side cart — CONCLUDED (Var B "New gift
    // design white" winner, test 86fa078c-ef27-4b7f-a2fc-0fbbdd1bf6b7).
    // The grouped white-card gift layout is now the unconditional default in
    // c-subscription-gift-drawer.css/.js + 0-cart-items.liquid, so there is no
    // longer a body class to flip here.

    // RA_PT_CART | Compare-at price on sidecart — CONCLUDED (Var B "Crossed price
    // no gift" winner, test 16682599-e465-4c6d-9482-03d954e5452f). The
    // gift-excluded compare-at after the live total is now the unconditional
    // default in c-subscription-gift-drawer.css + 0-cart-footer.liquid.

    // RA_PT_PDP_1 | Subscription switcher — Var A vs Toggle (product.default-subscription)
    const subscriptionSwitcher = window.igData?.user.getTestGroup("6747f7ce-3459-4dfd-80b1-b153f6458f57");
    if (subscriptionSwitcher?.name === "Var A - Subscription switcher") {
        document.body.classList.add("c-subscriptionSwitcher-varA");
    }

    // V_PT_PDP | Subscription by default when theme.default_subscription is undefined
    // NB: the actual default purchase-type flip is wired in assets/w-product-template.js,
    // which reads this same test group directly (the body class is informational only).
    const subscriptionByDefault = window.igData?.user.getTestGroup("4da94897-39d1-485a-97a6-dc42c3434972");
    if (subscriptionByDefault?.name === "Var A - Subscription by default") {
        document.body.classList.add("c-subscriptionByDefault-varA");
    }

    // RA_PT_PDP_4 | Crisp Pop Up Placement — CONCLUDED (Var B "No proactive box" winner,
    // test 8e525de9-4a3d-4968-bd24-b897c178178e). Suppressing Crisp's proactive prompts and
    // lifting the launcher above the sticky add-to-cart bar are now the unconditional
    // defaults in assets/w-product-template.css, so there is no longer a body class to flip.

    // PT_CART | Samples gift threshold — CONCLUDED (Control winner, test
    // 2ef2fd5c-ccb9-4fbe-bd9f-aea15b0cd53c). Neither Var A ("Samples at 60€") nor
    // Var B ("No samples") beat Control, so the gift tiers stay as configured in the
    // theme settings (samples @40€ / hydratation @95€ / tier 3 @120€) and the variant
    // overrides in assets/w-sidecart.js + c-subscription-gift-drawer.css are removed.

    // RA_PT_HP_2 | HP Merchandising Super Coffee — CONCLUDED (Control winner, test
    // f73ce556-e0fd-47f3-87d2-73b5e6ee8f1f). Var A ("Hide Super Coffee") did not beat
    // Control, so the "Offre du moment" Super Coffee section stays visible as
    // configured in templates/index.json, and the variant's hide-on-body-class
    // override in assets/c-custom.css is removed.

    // RA_PT_PDP_4 | Free Travel Mug
    // Var A keeps the travel mug in the welcome gift set; Control gets the set without it.
    // The gift data itself is swapped through window.cFreeTravelMugVarA() above — this class
    // is a CSS/debugging hook only.
    if (window.cFreeTravelMugVarA?.()) {
        document.body.classList.add("c-freeTravelMug-varA");
    }

    // V_PT_CART_25 | Remove Extra Upsell Screens Between Cart and Checkout
    // The post-cart flow is drawer -> screen 2 "Ajouter des produits supplementaires"
    // (upsell collections) -> screen 3 "Essayez de notre infusion du moment" (featured
    // product) -> checkout. The three arms are the remaining cells of that 2x2:
    //   Var A - drops screen 2, keeps screen 3
    //   Var B - drops both
    //   Var C - keeps screen 2, drops screen 3
    // Intelligems names: "Control", "Var A - Remove one upsell",
    // "Var B - Remove both upsells", "Var C - Remove offer screen".
    const ptCart25 = window.igData?.user.getTestGroup("9052fe33-0e3b-47b1-8f76-8d3279eb2e9e");
    if (ptCart25?.name?.startsWith("Var A")) {
        document.body.classList.add("c-ptCart25VarA");
    } else if (ptCart25?.name?.startsWith("Var B")) {
        document.body.classList.add("c-ptCart25VarB");
    } else if (ptCart25?.name?.startsWith("Var C")) {
        document.body.classList.add("c-ptCart25VarC");
    }

    // HP | Media grid 3 vs 5 blocks vs full screen hero (see window.cHpMediaGridClass above)
    const hpMediaGridClass = window.cHpMediaGridClass();
    if (hpMediaGridClass) {
        document.body.classList.add(hpMediaGridClass);
    }

    // RA_PT_PDP | Multiref block
    // Var A hides the flavor picker (snippets/multiref-picker.liquid) on individual product pages.
    // Control keeps it visible. Groups with always_show_picker (Noel) ignore the flag via
    // .multiref-picker--forced.
    const multirefPicker = window.igData?.user.getTestGroup("7a2d6bd9-a40d-4108-bcfe-38fc18f323d1");
    if (multirefPicker?.name === "Var A") {
        document.body.classList.add("c-multirefPicker-hidden");
    }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});